import { api } from "./client";
import type { ChampRole, ChampStatus } from "./champs";
import type { CustomerSearchHit, TicketSearchHit } from "./customers";

/**
 * The top bar's one search: `GET /v1/search?q=` (champ-panel contract §1).
 * Customers exactly as `/v1/customers/search` returns them, tickets as today,
 * champs new. Each group is empty without its permission (`customers.view`,
 * `tickets.view`, `champs.view`); the route admits any of customers or champs.
 */
export interface ChampSearchHit {
  id: number;
  /** "CH1234". */
  code: string | null;
  name: string;
  role: ChampRole;
  status: ChampStatus;
  /** Never onboarded. */
  isLead: boolean;
  isDeactivated: boolean;
  /** Masked. */
  phone: string;
  /** The first active area. */
  area: string | null;
  match: {
    field: "phone" | "whatsapp" | "alternative" | "emergency" | "id" | "code" | "name";
    value: string;
  };
}

export interface SearchResult {
  customers: CustomerSearchHit[];
  champs: ChampSearchHit[];
  tickets: TicketSearchHit[];
}

export const searchEverything = (q: string, signal?: AbortSignal) =>
  api.get<SearchResult>(`/search?q=${encodeURIComponent(q)}`, signal ? { signal } : {});
